export function createAction(type, payload, meta = {}) {
    const action = { type, payload, meta };
    if (type && type.includes('EXTRA_LESSONS_PRICE')) {
        console.log('[utils/actions createAction] Creating action', {
            type,
            payload,
            meta,
            isPromise: payload && typeof payload.then === 'function',
            timestamp: new Date().toISOString()
        });
    }
    return action;
}

export function fulfilled(type) {
    return `${type}_FULFILLED`;
}

export function pending(type) {
    return `${type}_PENDING`;
}

export function rejected(type) {
    return `${type}_REJECTED`;
}



// WEBPACK FOOTER //
// ./src/utils/actions.js